import { DietaryLabels, NutritionFacts, Price} from './restaurant.model';
import { Item, Modifier, Variation } from './catalog.model';
import { DailyAvailability } from '../dto/catalog.dto';


export enum ProductCollapseState {
  SHOW = 'SHOW',
  HIDE = 'HIDE'
}

export class MenuItem {
  constructor(
    public name: string,
    public id: string,
    public price: Price = new Price(),
    public isShow: boolean = true,
    public onByDefault: boolean = false,
    public hiddenFromCustomer: boolean = false,
    public isSelected: boolean = false,
    public soldOut: boolean = false
  ) {
  }
}

export class MenuItemVariation {
  constructor(
    public name: string = null,
    public id: string = null,
    public price: Price = new Price(),
    public quantityRemaining: number = null,
    public openingLeadTime: string = '',
    public closingLeadTime: string = '',
    public pickupLeadTime: string = '',
    public isLeadTimesEnabled: boolean = false,
    public allowCustomNote: boolean = false,
    public dailyAvailability: DailyAvailability[] = null,
    public availableInFulfillments: string = '',
    public availableFrom: Date = new Date(),
    public availableUntil: Date = new Date(),
    public isDailyRestrictionEnabled: boolean = false,
    public isFulfillmentRestrictionEnabled: boolean = false,
    public isStartEndDatesEnabled: boolean = false,
    public useInventory: boolean = false,
    public trackInventory: boolean = false,
    public disabled: boolean = false,
    public soldOut: boolean = false,
    public modifiersDisabled: boolean = false,
    public modifierList: Modifier[] = [],
    public throttlingEstimation: string = null,
    public nutrition_facts_enabled: boolean = false,
    public nutrition_facts: NutritionFacts = new NutritionFacts(),
    public dietary_labels_enabled: boolean = false,
    public dietary_labels: DietaryLabels =  new DietaryLabels(),
    public containAlcohol: boolean = false,
  ) {
  }
}

export class MenuItemVariationValidation {
  constructor(
    public readonly item: CartItem,
    public isValid: boolean
  ) {
  }
}

export class MenuItemData {
  constructor(
    public id: string,
    public category_id: string,
    public name: string,
    public image: string,
    public quantity: number,
    public variation: Variation,
    public modifiers: Modifier[] = [],
    public description: string = null,
    public totalItemPrice?: Price,
    public specialInstructions: string = ''
  ) {
    let totalPrice = this.variation.price_money.amount;
    for (const modifier of modifiers) {
      totalPrice += (modifier.price_money.amount || 0) * (modifier.quantity || 1);
    }
    this.totalItemPrice = new Price(totalPrice);
  }

  public calculateTotalPrice(): void {
    let totalBalance = this.variation.price_money.amount;
    this.modifiers.forEach((modifier) => {
      totalBalance += (modifier.price_money.amount || 0) * (modifier.quantity || 1);
    });
    this.totalItemPrice.amount = totalBalance;
  }
}

export class MenuItemForPayment {
  constructor(
    public locationId: string,
    public categoryId: string,
    public category_id: string,
    public itemId: string,
    public item: MenuItemData,
    public isService: boolean = false,
    public isFutureOrder: boolean = false,
    public throttlingEstimation: string = null,
    public metadata: any = null,
    public originalItem: Item = new Item(),
    public chosenVariation: Variation = new Variation(),
    public discountAmount: number = 0,
    public discountName: string = null,
    ) {
  }
}
export class CartItem {
  constructor(
    public name: string = null,
    public variation: Variation = new Variation(),
    public modifiers: Modifier[] = [],
    public quantity: number = 0,
    public specialInstructions: string = null,
    public totalItemPrice?: Price,
    public locationId?: string,
    public categoryId?: string,
    public isService?: boolean,
    public isFutureOrder?: boolean,
    public throttlingEstimation?: string,
    public metadata?: any,
    public image?: string,
    public discountAmount: number = 0,
    public discountName: string = null
  ) {}
}
